import api from '@/services/api'
import type { UserProfileListResponse } from './types'

export const ProfilesV2Service = {
  getProfiles() {
    return api.get<UserProfileListResponse>('/v2/user-profiles')
  },
}
